import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  margin: 2rem 0 0 0;
  height: fit-content;
  justify-content: center;
  grid-area: area_variation;
  margin-bottom: 3% ;
  @media (max-width: 820px) {
    margin: 1rem 0 0;
    padding-left: 2% ;
    justify-content: flex-start;
  }
`;

export const WrapperContent = styled.div`
  margin-left: 1rem;
  width: min(1190px, 100%);

  @media (max-width: 820px) {
    width: 97%;
    margin-left: 0;
  }

  @media (max-width: 409px) {
    width: 85%;
    margin-left: 1rem;
  }
`;

export const TitleSection = styled.b`
  font-size: 1rem;
  color: var(--color-title-sectoin);
`;

export const WrapperCard = styled.div`
  display: flex;
  padding-top: 1rem;
  justify-content: space-between;

  @media (max-width: 820px) {
    align-items: center;
    flex-direction: column;
  }
`;
